export const TERMSCONDITIONS = {
    URL: {
        commonUrl: 'assets/pdf/Terms-of-Use-for-AT&T-Device-Enrollment2025.pdf',
        commonUrl2: 'https://www-01.ibm.com/software/passportadvantage/pa_agreements.html',
        commonUrl3: 'http://serviceguidenew.att.com/sg_flashPlayerPage/IBM_MaaS360 ',
        addpmdmUrl: 'https://www.ibm.com/support/customer/csol/contractexplorer/cloud/csa/us-en',
        dmpgztpUrl: 'https://www.wireless.att.com/businesscenter/en_US/pdf/device-enrollment-enablement-program-attachment-zero-touch.pdf',
        dmpskmeUrl: 'https://www.wireless.att.com/businesscenter/en_US/pdf/device-enrollment-enablement-program-attachment-KME.pdf',
        termsUrl: 'assets/pdf/Terms-of-Use-for-AT&T-Device-Enrollment2025.pdf'
    }
};
